// extracted by mini-css-extract-plugin
export default {"icon":"tire-attribute-icon__icon___QoIaE"};